import { setTokenHeader } from "../../services/api"
import { SET_CURRENT_USER, UPDATE_USER } from "../actionTypes"
import { addError } from "./errors"
import { showLoader, hideLoader } from "./loader"
import { showAlert } from "./alert"
import { fetchFiles } from "./files"
import { fetch as fetchBrand } from "./brand"
import axios from 'axios';
import { AlertJsMessage } from './../../helpers.js';
import { auth } from './../../firebase';

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user
  }
}

export function setAuthorizationToken(token) {
  setTokenHeader(token)
}

export const verifyGateWayUser = (code) => (dispatch) => {
  return new Promise((respond, rej) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/updateToken', {
      code: code,
      grant_type: 'authorization_code'
    }).then((res) => {
      respond(res);
    }).catch(() => {
      rej();
    })
  });
}
export const logout = () => (dispatch) => {

  dispatch(showLoader());
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL_AUTH;
  return new Promise((response, reject) => {
    const url = `auth/logout`;
    axios.post(url, {}).then((res) => {
      dispatch(hideLoader());
      localStorage.clear()
      response();
    }).catch(() => {
      dispatch(hideLoader());
      localStorage.clear()
      response();
    })
  });
}

export const fetchUser = (id) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    let query = id ? { params: { id: id } } : {};
    axios.get('users', query).then((userData) => {
      dispatch({
        type: UPDATE_USER,
        payload: userData.data
      });
      if (userData.data.type.includes('brand') || userData.data.type.includes('corporate')) {
        dispatch(fetchBrand());
      }
      response(userData.data);
    }).catch(err => {
      dispatch(hideLoader());
      localStorage.clear()
    });
  })
}

function checkUserAlreadyLoggedIn(dispatch) {
  let returnObj;
  if (localStorage.getItem('jwtToken')) {
    returnObj = new Promise((res, rej) => {
      dispatch(addError("You have already logged in another window. Please refresh the page."));
      rej();
      return;
    })
  } else {
    returnObj = false;
  }
  return returnObj;
}

async function handleSignInResponse(response, dispatch, rej, res) {
  const user = response.data;
  if (user) {
    if (user.type.includes('basic') && user.type.length === 1) {
      dispatch(addError("Sorry, you are not allowed to log in to the web platform."));
      rej();
      return;
    }
    localStorage.setItem('jwtToken', user.token)
    localStorage.setItem('id', user._id)
    setAuthorizationToken(user.token);
    if(user.fb_token) {
      await auth.signInWithCustomToken(user.fb_token);
      delete user.fb_token;
    }
    dispatch(fetchUser());
    dispatch(fetchFiles(user._id));
    dispatch(setCurrentUser(user))
    if (user.type.includes('brand') || user.type.includes('corporate')) dispatch(fetchBrand());
    res()
  } else {
    AlertJsMessage("Email/Password combination not recognized.");
    rej();
  }
}

function SignIn(type, dispatch, userData) {
  const isLoggedIn = checkUserAlreadyLoggedIn(dispatch);
  if (!isLoggedIn) {
    dispatch(showLoader());
    return new Promise((res, rej) => {
      const url = `auth/login`;
      return axios.post(url, {
        email: userData.email,
        password: userData.password,
        platform: 'web'
      })
        .then(async(response) => {
          dispatch(hideLoader());
          await handleSignInResponse(response, dispatch, rej, res);
        })
        .catch(err => {
          dispatch(hideLoader());
          if (err.response) {
            dispatch(addError(err.response.data.error.message));
          }
          rej()
        });
    })
  } else {
    return Promise.reject();
  }
}

function SignUp(type, dispatch, userData) {
  return new Promise((res, rej) => {
    const url = `auth/${type}`;
    dispatch(showLoader());
    return axios.post(url, userData)
      .then(async(response) =>  {
        dispatch(hideLoader());
        dispatch(showAlert(response.data.message));
        res()
      })
      .catch(err => {
        handleError(dispatch, err);
        rej()
      });
  })
}

export function authUser(type, userData) {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL_AUTH;
  let returnObj;
  return dispatch => {
    switch (type) {
      case 'signin':
        returnObj = SignIn(type, dispatch, userData);
        break;
      case 'signup':
        returnObj = SignUp(type, dispatch, userData);
        break;
      default:
    }
    return returnObj;
  }
}

export const updateUser = (userData) => (dispatch) => {
  dispatch(showLoader());
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.patch('users', userData).then((userData) => {
      dispatch(hideLoader());
      dispatch(showAlert('Data updated successfully.'));
      response(userData);
    }).catch(err => {
      dispatch(hideLoader());
      if (err.response) {
        dispatch(showAlert(err.response.data.error.message, true));
      }
      reject(err)
    });
  })
}

export const sendInvitations = (emails) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/sendInvitations', { emails: emails }).then((res) => {
      dispatch(showAlert(res.data.message));
      response(res);
    }).catch(err => {
      if (err.response) {
        dispatch(showAlert(err.response.data.error.message, true));
      }
      reject(err)
    });
  })
}

export const createUser = (user) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post('users/createUser', user).then((resp) => {
      dispatch(hideLoader());
      dispatch(showAlert(resp.data.message));
      response(resp.data);
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

export const sendPushMessage = (messageObj) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post('users/sendPushMessage', messageObj).then((resp) => {
      dispatch(hideLoader());
      dispatch(showAlert(resp.data.message));
      response(resp.data);
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

export const deleteAccount = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post(`users/sendConsumerDeleteToken`, data).then((res) => {
      dispatch(hideLoader());
      dispatch(showAlert(res.data.message));
      response(res.data);
    }).catch(err => {
      dispatch(hideLoader());
      if (err.response) {
        dispatch(addError(err.response.data.message));
      }
      reject(err)
    });
  })
}

export const verifyDeleteAccountToken = (token) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/verifyDeleteAccountToken', { token })
      .then((res) => {
        response(res);
      }).catch(err => {
        reject(err)
      });
  })
}



export const getPaymentToken = () => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.get('payments/clientToken', {}).then((res) => {
      dispatch(hideLoader());
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}


export const updateReferenceCode = (user) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    const userId = user._id;
    delete user._id;
    axios.post(`users/updateReferenceCode/${userId}`, user).then((res) => {
      dispatch(hideLoader());
      dispatch(showAlert(res.data.message));
      response(res.data);
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

export const cancelSubscription = () => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post(`users/cancelSubscription`).then((resposeSubscription) => {
      dispatch(hideLoader());
      dispatch(showAlert(resposeSubscription.data.message));
      response(resposeSubscription.data);
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

export const changeEmail = (email) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/changeEmail', { email: email }).then((res) => {
      dispatch(showAlert(res.data.message));
      response(res);
    }).catch(err => {
      err.response && dispatch(showAlert(err.response.data.error.message, true));
      reject(err);
    });
  })
}

export const verifyChangeEmailToken = (token) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/verifyEmailVerificationToken', { token, verificationType: 'changeEmail' })
      .then((res) => {
        response(res);
      }).catch(err => {
        reject(err)
      });
  })
}

export const changePassword = (oldPassword, password) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/changePassword', { oldPassword, password }).then((res) => {
      response(res);
      dispatch(showAlert(res.data.message));
    }).catch(err => {
      err.response && dispatch(showAlert(err.response.data.error.message, true));
      reject(err)
    });
  })
}

export const forgotPassword = (email) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/forgotPassword', { email })
      .then((res) => {
        response(res);
        dispatch(showAlert(res.data.message))
      }).catch(err => {
        dispatch(showAlert(err.response.data.message, true))
        reject(err);
      });
  })
}

export const verifyResetPasswordToken = (token) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/verifyResetPasswordToken', { token })
      .then((res) => {
        response(res);
      }).catch(err => {
        reject(err)
      });
  })
}

export const resetPassword = (token, password) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    axios.post('users/resetPassword', { token, password })
      .then((res) => {
        response(res);
        dispatch(showAlert(res.data.message))
      }).catch(err => {
        reject(err);
        dispatch(showAlert(err.message, true));
      });
  })
}

export const sendContactMessage = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post('users/sendContactMessage', data).then((resContact) => {
      dispatch(hideLoader());
      dispatch(showAlert(resContact.data.message));
      response(resContact.data);
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

export const sendBrandRequest = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post('users/sendBrandRequest', data).then((resPonse) => {
      dispatch(hideLoader());
      dispatch(showAlert(resPonse.data.message));
      response(resPonse.data);
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

export const checkUserSubscribed = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post('users/checkUserSubscribed', data).then((res) => {
      dispatch(hideLoader());
      response(res.data);
    }).catch(err => {
      dispatch(hideLoader());
      const errror = err.response.data.error;
      if (!errror.isAccountSet) {
        dispatch(addError(errror.message));
        reject(errror);
        return;
      }
      reject(errror)
    });
  })
}

export const updateFollower = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    const email = data.email;
    delete data.email;
    axios.post(`users/updateFollower/${email}`, data).then((res) => {
      dispatch(hideLoader());
      response(res.data);
    }).catch(err => {
      dispatch(hideLoader());
      if (err.response) {
        dispatch(showAlert(err.response.data.error.message));
      }
      reject(err)
    });
  })
}

export const signUpAgencyUser = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post(`users/createAgencyUser`, data).then((res) => {
      dispatch(hideLoader());
      response(res.data);
    }).catch(err => {
      dispatch(hideLoader());
      reject(err.response.data.error.message)
    });
  })
}


export const signUpFollower = (data) => (dispatch) => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    dispatch(showLoader());
    axios.post(`users/signUpFollower`, data).then((res) => {
      dispatch(hideLoader());
      response(res.data);
    }).catch(err => {
      dispatch(hideLoader());
      if (err.response) {
        dispatch(addError(err.response.data.error.message));
      }
      reject(err)
    });
  })
}

export const verfiyMobileLogin = (data) => dispatch => {
  return new Promise((response, reject) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL_AUTH;
    dispatch(showLoader());
    axios.post(`auth/loginByMobile`, data).then((res) => {
      dispatch(hideLoader());
      const user = res.data;
      if (user) {
        localStorage.setItem('jwtToken', user.token)
        setAuthorizationToken(user.token);
        dispatch(fetchUser());
        dispatch(fetchFiles(user._id));
        dispatch(setCurrentUser(user))
        if (user.type.includes('brand') || user.type.includes('corporate')) dispatch(fetchBrand());
        response(res.data);
      } else {
        AlertJsMessage("Email/Password combination not recognized.");
        reject();
      }
    }).catch(err => {
      handleError(dispatch, err);
      reject(err)
    });
  })
}

function handleError(dispatch, err) {
  dispatch(hideLoader());
  if (err.response) {
    dispatch(showAlert(err.response.data.error.message || err.response.data.error.message, true));
  }
}




// WEBPACK FOOTER //
// ./src/store/actions/auth.js